import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import {FirebaseProvider} from './context/FirebaseContext';
import {RoutesProvider} from "./routing";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <FirebaseProvider>
      <RoutesProvider/>
    </FirebaseProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
